import React from 'react';
import cn from 'classnames';

import useCollapse from './useCollapse';

import './collapse.scss';

interface Props {
    isCollapsed: boolean;
    duration?: number;
}

const Collapse: React.FC<Props> = ({
    isCollapsed,
    duration = 500,
    children,
}) => {
    const { isAnimating, nodeRef } = useCollapse({
        isCollapsed,
        duration,
    });

    return (
        <div
            styleName={cn('container', {
                'is-collapsed': isCollapsed,
                'is-animating': isAnimating,
            })}
        >
            {(isAnimating || !isCollapsed) && (
                <div ref={nodeRef}>{children}</div>
            )}
        </div>
    );
};

export default Collapse;
